import React from 'react';

function Projects() {
    return (
        <div class="project-container">
            <div class="project-list">
                <div class="project">
                    <span class="proj-title">TurboQuant benchmark</span>
                    <span class="proj-date">April 2026</span>
                    <p class="proj-desc">TurboQuant implementation benchmarked on Gemma4 26b. Compared baseline FP16 weights to quantized 3-bit version. Tested memory and quality metrics on my NVIDIA DGX Spark. Wrote an article discussing my findings on <a href="https://medium.com/@harrison.m.carpenter/turboquant-revolutionizing-local-ai-with-extreme-compression-9969946a6c8d">Medium</a></p>
                    <a class="proj-link" href="https://github.com/harrisonc0417/TurboQuant-bench">Link</a>
                </div>
                <div class="project">
                    <span class="proj-title">KNN-CUDA: GPU-accelerated K-Nearest Neighbors</span>
                    <span class="proj-date">March 2026</span>
                    <p class="proj-desc">CUDA implementation of K-Nearest Neighbors tested on my NVIDIA DGX Spark. Supports both classification and regression.</p>
                    <a class="proj-link" href="https://github.com/harrisonc0417/KNN-CUDA">Link</a>
                </div>
                <div class="project">
                    <span class="proj-title">From Hopper to Blackwell: A comparison of modern NVIDIA GPU architectures</span>
                    <span class="proj-date">Febuary 2026</span>
                    <p class="proj-desc">Report written for ECE332: Computer Architecture II by myself and <a href="https://www.linkedin.com/in/amelia-kremer/">Amelia Kremer</a></p>
                    <a class="proj-link" href="https://docs.google.com/document/d/1p9hmQ9XACaEoKHl6AC72XOFVksM2GVaSGD4IpjOTE0Q/edit?tab=t.x83rxtp2p0em">Link</a>
                </div>
                <div class="project">
                    <span class="proj-title">GeoGuessr: Hierarchical classifier and regressor for street view images</span>
                    <span class="proj-date">November 2025</span>
                    <p class="proj-desc">Class project for CSSE416: Deep Learning at Rose-Hulman. The hierarchical classifier determines which continent the image was taken on, then the image vector is sent to a regression model trained on images from that continent and outputs it's latitude and longitude.</p>
                    <a class="proj-link" href="https://github.com/federerl/geoguessr/tree/MoveCodefromServertoGit">Link</a>
                </div>
                <div class="project">
                    <span class="proj-title">CAPTCHA solver with Deep Learning</span>
                    <span class="proj-date">August 2025</span>
                    <p class="proj-desc">A small tutorial I followed to learn more about CNNs and deep learning models</p>
                    <a class="proj-link" href="https://github.com/rhit-carpenhm/captcha-solver">Link</a>
                </div>
            </div>
        </div>
    )
}

function Project(title, desc, date, link){
    return (
        <div class="project">
            <span class="proj-title">{title}</span>
            <span class="proj-date">{date}</span>
            <p class="proj-desc">{desc}</p>
            <a class="proj-link" href={link}>Link</a>
        </div>
    )
}

export default Projects;